/** @file Hierarchy state: the tree of the document, the selected rows, and the shared tree-panel state. */
import { useMemo } from 'react';
import { useStore } from 'zustand';
import { docIndex } from '@pose2d/format/doc/docIndex';
import type { Doc } from '@pose2d/format/types';
import { useTreePanel } from '../../forms/useTreePanel';
import { selectionStore } from '../../stores/selectionStore';
import { buildHierarchy } from './buildHierarchy';

/** Bones start expanded; slots start closed (their placeholders show on demand). */
export function useHierarchyState(doc: Doc) {
  const index = useMemo(() => docIndex(doc), [doc]);
  const nodes = useMemo(() => buildHierarchy(doc, index), [doc, index]);
  const selection = useStore(selectionStore);
  const selected = useMemo(() => new Set([...selection.bones, ...selection.slots]), [selection]);
  const panel = useTreePanel(() => new Set(Object.keys(doc.bones)));
  return { ...panel, doc, index, nodes, selected };
}
